<template>
    <div>
        <el-dialog
            :visible.sync="dialogVisible"
            append-to-body
            :close-on-click-modal="false"
            title=""
            custom-class="buy-pop"
        >
            <div class="purchase-menu tc" v-loading="loading">
                <p class="title">产品图片违禁检测套餐</p>
                <p class="subTitle">一键检测产品主图/详情图违禁词<span>预防职业打假</span></p>
                <div class="menu-box">
                    <div
                        class="menu-item"
                        v-for="(item, index) in menuList"
                        :key="item.code"
                        :class="{ actived: index === curIndex }"
                        @click="curIndex = index"
                    >
                        <div class="menu-title">套餐{{ index + 1 }}</div>
                        <div class="price-part">
                            <div>
                                <div>￥</div>
                                <div>{{ item.price }}</div>
                                <div>/检测{{ item.quantity }}个</div>
                            </div>
                        </div>
                        <div class="per-price">单价：{{ item.perPrice }}{{ item.perPriceUnit }}</div>
                    </div>
                </div>
                <div class="btn" @click="buy(menuList[curIndex])">预防职业打假，立即支付 ></div>
            </div>
        </el-dialog>
        <el-dialog :visible.sync="qrcodeShow" width="435px" append-to-body @closed="cancel">
            <div class="pay-pop">
                <img src="../../../../../assets/images/check/success.png" />
                <div>已下单，请支付</div>
                <div><img src="../../../../../assets/images/check/zfb.png" />支付宝扫一扫支付</div>
                <div>
                    <span>{{ buyInfo.price }}</span
                    >元
                </div>
                <div class="img-part">
                    <img :src="qrcodeURL" />
                    <img src="../../../../../assets/images/check/zfb-cut.png" />
                </div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
export default {
    name: 'PurchaseMenu',
    data() {
        return {
            imSign: '',
            curIndex: 0,
            qrcodeURL: '',
            buyInfo: {},
            loading: false,
            menuList: [],
            dialogVisible: false,
            token: localStorage.getItem('accessToken') || localStorage.getItem('sjzlAccessToken'),
            qrcodeShow: false,
        };
    },
    methods: {
        cancel() {
            dazeTask.remove(this.imSign);
        },
        show() {
            this.dialogVisible = true;
        },
        buy(item) {
            this.loading = true;
            this.$ajax
                .post('//api.fjdaze.com/kuaio/api/ForbiddenWord/PackagePay/GetPackageQrcodeV2', {
                    code: item.code,
                })
                .then((res) => {
                    this.loading = false;
                    this.qrcodeURL = res.result.url;
                    this.buyInfo = item;
                    this.qrcodeShow = true;
                    this.imSign = res.result.imSign;
                    dazeTask.register(res.result.imSign, (data) => {
                        if (data.PaySuccess) {
                            this.$message.success('支付成功');
                            this.qrcodeShow = false;
                            this.dialogVisible = false;
                            this.$emit('success');
                        }
                    });
                });
        },
    },
    created() {
        this.$ajax.post('//api.fjdaze.com/kuaio/api/ForbiddenWord/Package/SearchFwPackage', {}).then((res) => {
            this.menuList = res.result;
        });
    },
};
</script>
<style lang="scss" scoped>
.pay-pop {
    text-align: center;
    > div:nth-child(2) {
        font-size: 22px;
        line-height: 28px;
        font-weight: bold;
        margin-top: 17px;
    }
    > div:nth-child(3) {
        font-size: 16px;
        line-height: 16px;
        font-weight: bold;
        margin-top: 30px;
        img {
            margin-right: 3px;
        }
    }
    > div:nth-child(4) {
        color: #f82c32;
        font-weight: bold;
        font-size: 12px;
        margin-top: 5px;
        span {
            font-size: 20px;
        }
    }
}
.per-price {
    line-height: 40px;
    border-top: 1px dotted #e6e6e6;
    color: #999999;
}
.price-part {
    display: flex;
    align-items: center;
    height: 80px;
    > div {
        display: flex;
        align-items: flex-end;
        justify-content: center;
        width: 100%;
        > div {
            &:nth-child(1) {
                font-size: 16px;
                color: #ff0000;
                padding-bottom: 3px;
            }
            &:nth-child(2) {
                font-size: 40px;
                color: #ff0000;
                font-weight: bold;
            }
            &:nth-child(3) {
                padding-bottom: 4px;
                margin-left: 5px;
            }
        }
    }
}
.purchase-menu {
    cursor: pointer;
    font-size: 14px;
    line-height: 1;
    .orange {
        color: #ff9000;
    }
    .title {
        color: #333;
        font-size: 24px;
        font-weight: bold;
        line-height: 30px;
    }
    .subTitle {
        margin-top: 15px;
        color: #999;
        span {
            color: #ff6000;
            margin-left: 10px;
        }
    }
    .menu-box {
        display: flex;
        justify-content: center;
        margin-top: 36px;
        .menu-item {
            width: 222px;
            height: 172px;
            position: relative;
            border-radius: 4px;
            box-shadow: 0px 0px 8px 1px rgba(0, 0, 0, 0.1);
            border: 1px solid #fff;

            .menu-title {
                font-size: 18px;
                line-height: 50px;
                color: #fff;
                text-align: center;
                background: #fff5e9;
                color: #333;
            }
            + .menu-item {
                margin-left: 20px;
            }
            &:hover {
                border: 1px solid #ff6000;
            }
        }
        .actived {
            &:before {
                content: '';
                position: absolute;
                width: 59px;
                height: 23px;
                background: url('../../../../../assets/images/check/actived.png');
                top: 0;
                right: 0;
            }
        }
    }
    .btn {
        width: 325px;
        height: 46px;
        background: linear-gradient(90deg, #ff7700 0%, #ff6000 100%);
        border-radius: 23px 23px 23px 23px;
        font-size: 16px;
        color: #fff;
        font-weight: bold;
        line-height: 46px;
        margin: 29px auto 0 auto;
    }
}
.img-part {
    overflow: hidden;
    margin-top: 13px;
    > img {
        float: left;
        height: 180px;
        border: 1px dashed rgb(212, 212, 212);
        &:nth-child(2) {
            margin-left: 20px;
        }
    }
}
</style>
